import React, { useState, useEffect } from "react";
import { useApiRequest } from "../helper/api";
import { toast } from "react-toastify";
import { useAuth } from "../context/LoginContext";
import logo from "../assets/IonTime.png";
import toplogo from "../assets/IonIdealogo.png";
import bgImg from "../assets/leftIontimeLogo.jpg";
import { useNavigate } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";

const TalentTigersLoginPage: React.FC = () => {
    const [email, setEmail] = useState<string>("");
    const [otp, setOtp] = useState<string>("");
    const [isOtpRequested, setIsOtpRequested] = useState<boolean>(false);
    const [timer, setTimer] = useState<number>(120); // 2 minute timer
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { fetchData } = useApiRequest();
    const { loginTT } = useAuth();
    const navigate = useNavigate();

    // Handle the countdown for OTP request
    useEffect(() => {
        let countdown: NodeJS.Timeout;
        if (isOtpRequested && timer > 0) {
            countdown = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            setIsOtpRequested(false);
            setTimer(120); // Reset timer after 2 minute
        }
        return () => clearInterval(countdown);
    }, [isOtpRequested, timer]);

    // API to request OTP
    const requestOtp = async () => {
        if (!email) {
            toast.error("Please enter your email");
            return;
        }

        setIsLoading(true);
        try {
            const payload = { email: email };
            // Call your API to request OTP
            const response = await fetchData("/user/request-otp", {
                method: "POST",
                data: payload,
            });
            console.log("token tt", response);
            if (response?.status) {
                if (typeof response.data === "string") {
                    toast.error(response?.data);
                    return null;
                }
                setTimer(120); // Start the 2 minute timer
                setIsOtpRequested(true);
                return response.data;
            }
            return null;
        } catch (error) {
            console.error("Error requesting OTP:", error);
            toast.error("Failed to request OTP");
        } finally {
            setIsLoading(false);
        }
    };

    // API to verify OTP
    const verifyOtp = async () => {
        if (!otp) {
            toast.error("Please enter OTP");
            return;
        }

        setIsLoading(true);
        try {
            const payload = { email, otp };
            // Call your API to verify OTP
            const response = await fetchData("/user/verify-otp", {
                method: "POST",
                data: payload,
            });
            console.log("verify token tt", response);
            if (response?.status) {
                if (typeof response.data === "string") {
                    toast.error(response?.data);
                    return null;
                }
                // Handle successful login here, e.g., redirect to another page
                loginTT(response.data);
            }
            return null;
        } catch (error) {
            console.error("Error verifying OTP:", error);
            toast.error("Failed to verify OTP");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='h-screen w-screen bg-gray-400 '>
            <div
                className={`fixed grid place-items-center  top-0 right-0 left-0 z-50 w-full inset-0 h-modal h-full justify-center items-center`}
                style={{ backgroundImage: `url(${bgImg})`, backgroundSize: "cover", backgroundPosition: "center" }}
            >
                <div className='absolute inset-0 bg-black opacity-50'></div>

                <img
                    src={toplogo}
                    loading='lazy'
                    className='w-64 mx-auto rounded-xl bg-white shadow-xl p-8 absolute top-5 left-1/2 transform -translate-x-1/2'
                />
                <div className='relative container m-auto px-6'>
                    <div className='m-auto '>
                        <div className='rounded-xl bg-white shadow-xl'>
                            <div className='px-8 py-4 pb-8 mt-24'>
                                <div className='space-y-4'>
                                    <img src={logo} loading='lazy' className='w-40 mx-auto' />
                                </div>
                                <div className='mt-6 grid space-y-4'>
                                    {!isOtpRequested && (
                                        <>
                                            {/* Email Input */}
                                            <input
                                                type='email'
                                                placeholder='Enter your Talent Tigers email'
                                                value={email}
                                                disabled={isOtpRequested || isLoading}
                                                onChange={(e) => setEmail(e.target.value)}
                                                className='border border-gray-300 rounded-lg w-full px-4 py-2'
                                            />
                                            {/* Request OTP Button */}
                                            <button
                                                onClick={requestOtp}
                                                className={`group h-10 px-6 border-2 border-gray-300 rounded-full transition duration-300 hover:border-blue-400 focus:bg-blue-50 active:bg-blue-100 ${isOtpRequested ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-100"
                                                    }`}
                                                disabled={isOtpRequested || isLoading}
                                            >
                                                {isOtpRequested ? `Request OTP again in ${timer}s` : "Request OTP"}
                                            </button>{" "}
                                        </>
                                    )}
                                    {/* OTP Input */}
                                    {isOtpRequested && (
                                        <>
                                            <p className='font-normal text-xs text-blue-600 dark:text-blue-500 my-0 py-0'>
                                                Request OTP again in {timer}s
                                            </p>
                                            <input
                                                type='text'
                                                placeholder='Enter OTP'
                                                value={otp}
                                                onChange={(e) => setOtp(e.target.value)}
                                                className='border border-gray-300 rounded-lg w-full px-4 py-2'
                                            />

                                            {/* Verify OTP Button */}
                                            <button
                                                onClick={verifyOtp}
                                                className='group h-10 px-6 border-2 border-gray-300 rounded-full transition duration-300 hover:border-blue-400 focus:bg-blue-50 active:bg-blue-100'
                                                disabled={isLoading}
                                            >
                                                Login
                                            </button>
                                        </>
                                    )}

                                    {isLoading && <p className='text-center mt-4'>Loading...</p>}
                                </div>
                                <div className='inline-flex items-center justify-center w-full my-5'>
                                    <hr className='w-40 h-1 my-0 bg-gray-200 border-0 rounded dark:bg-gray-700' />
                                    <div className='absolute px-1 text-sm -translate-x-1/2 bg-white left-1/2 dark:bg-gray-900'>
                                        or
                                    </div>
                                </div>

                                <button
                                    onClick={() => navigate("/login")}
                                    className='group h-10 px-6 border-2 w-full border-gray-300 rounded-full transition duration-300 hover:border-blue-400 focus:bg-blue-50 active:bg-blue-100'
                                >
                                    <div className='relative flex items-center space-x-4 justify-center'>
                                        <FcGoogle size={24} />
                                        <span className='block w-max font-semibold tracking-wide text-gray-700 text-sm transition duration-300 group-hover:text-blue-600 sm:text-base'>
                                            SignIn with Google
                                        </span>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TalentTigersLoginPage;
